import React, { useContext } from "react";
import { Bubbles } from "../../../../components/bubbles/Bubbles";
import { Diagram } from "../../../../components/diagram/Diagram";
import "./BubblesWidget.css";
import { formatDate3 } from "../../../../utils/dateFormats";
import { AppContext } from "../../../../appContext";

interface IBubblesWidgetProps {
    points: Array<{value: number, label: string}>;
    date?: Date;
    onSelect: (word: string) => void;
    onDelete?: (word: string) => void;
    selectedWord?: string;
    wordsWidgetData?: {
        counts: Array<{value: number, label: string}>;
        index: number;
        word: string;
    } | null;
    onBack?: () => void;
}

export const BubblesWidget = ({points, onSelect, onDelete, date, selectedWord, wordsWidgetData, onBack}: IBubblesWidgetProps) => {
    const { translate } = useContext(AppContext);

    const showStats = selectedWord && wordsWidgetData;

    return (
        <div className="meetingPage_wordTimes">
            <div className="wordTimesDiagram">
                {showStats ? (
                    <>
                        <div className="bubblesWidget_title_row">
                            <button 
                                className="bubblesWidget_back_btn"
                                onClick={onBack}
                                title={translate('common_back') || 'Back'}
                            >
                                <div className="bubblesWidget_back_icon"></div>
                            </button>
                            <div className="wordTimesDiagram_title">
                                {wordsWidgetData.counts[wordsWidgetData.index].value} {translate('times')}
                            </div>
                        </div>
                        <div className="wordTimesDiagram_text">
                            {translate('word_appeared_in_speech')
                                .replace('[word]', wordsWidgetData.word)
                                .replace('[session]', wordsWidgetData.counts[wordsWidgetData.index].label)}
                        </div>  
                        <Diagram points={wordsWidgetData.counts} activeIndex={wordsWidgetData.index}></Diagram>
                    </>
                ) : (
                    <>
                        <div className="wordTimesDiagram_title">
                            {translate('most_used_words')}
                        </div>
                        <div className="wordTimesDiagram_text">
                            {formatDate3(date) || '--.--'} {translate('session_statistics')}
                        </div>  
                        <Bubbles 
                            points={points}
                            onSelect={onSelect}
                            onDelete={onDelete}
                        ></Bubbles>
                    </>
                )}
            </div>
        </div>
    );
}
